import { render } from "./segments-autocomplete-multiselect.vue?vue&type=template&id=d280daf4&ts=true"
import script from "./segments-autocomplete-multiselect.ts?vue&type=script&lang=ts"
export * from "./segments-autocomplete-multiselect.ts?vue&type=script&lang=ts"

import "./segments-autocomplete-multiselect.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__